import React from "react";
import { imageUrl } from "@/lib/api";
import { Package, Layers, Box } from "lucide-react";

const ICONS = {
  roll: Layers,
  sheet: Layers,
  block: Box,
  box: Package,
};

const primaryPath = (item) => {
  if (Array.isArray(item?.image_paths) && item.image_paths.length) return item.image_paths[0];
  return item?.image_path || null;
};

const StockThumb = ({ item, size = "h-32 w-32", onClick }) => {
  const path = primaryPath(item);
  const url = path ? imageUrl(path) : null;
  const Icon = ICONS[item?.type] || Package;
  return (
    <div
      onClick={onClick}
      className={`${size} shrink-0 border-2 border-black rounded-xl overflow-hidden relative flex items-center justify-center ${
        onClick ? "cursor-zoom-in" : ""
      }`}
      style={{ background: item?.color_tag ? item.color_tag + "20" : "#F4F4F0" }}
    >
      {url ? (
        <img
          src={url}
          alt={item.name}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      ) : (
        <Icon size={36} strokeWidth={2} className="text-black/60" />
      )}
      {item?.color_tag && (
        <span
          className="absolute bottom-1 right-1 w-3 h-3 rounded-full border-2 border-black"
          style={{ background: item.color_tag }}
        />
      )}
    </div>
  );
};

export default StockThumb;
